import styled from 'styled-components'

export const TriggerMessageContainer = styled.div`
    width: 100%;
    padding: 16px 0;
    border-bottom: 1px solid var(--gray-400);

    .time-and-metrics {
        display: flex;
        gap: 10px;
        align-items: center;
    }

    .trigger-date {
        font-weight: 600;
        font-size: 13px;
    }
`
